export default function isPiecesla() {
  const url = (window.location.href || '').toLowerCase();
  return url.includes('piecesla');
}
